import { createSlice } from "@reduxjs/toolkit";

import { HeatingCalculationAPI } from "../../services/heating-calculation";

const HeatingCalculation = createSlice({
  name: "Heating Calculation slice",
  initialState: {
    calculations: [],
    total: 0,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(HeatingCalculationAPI.getAll.fulfilled, (state, action) => {
      const { total, calculations } = action.payload;

      state.calculations = calculations;
      state.total = total;
    });
  },
});

export default HeatingCalculation;
